import { ColorPiker } from './components/ColorPiker'
import { Link } from 'react-router-dom'
import PutData from '../../api/controlers/PutData'
import InputInfo from './components/InputInfo'
import { Password } from './components/PassWord'
import './style.css'

export function Setup(params: any) {
  return (
    <div className="setup">
      <Password />
      <h1>Setup</h1>
      <Link to="/"> Indietro</Link>
      <InputInfo />
      <ColorPiker />
      <PutData />
    </div>
  )
}
